import { render, staticRenderFns } from "./FilterSummaryOptionPuddingC.vue?vue&type=template&id=b0655c22&"
import script from "./FilterSummaryOptionPuddingC.vue?vue&type=script&lang=js&"
export * from "./FilterSummaryOptionPuddingC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports